import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from 'AppSrc/core/components/utility/alert';
import { clearAllErrorAlerts } from 'AppSrc/core/actions/actions-error-alert';

const ErrorAlertDisplay = ({
  errorAlerts,
  clearErrors,
}) => {

  if (errorAlerts.length === 0) {
    return null;
  }

  // we only display the first error.
  const {
    errorTitle: alertTitle,
    errorText: alertText,
  } = errorAlerts[0];

  const alertData = {
    className: 'alert-error',
    showFalse: false,
    alertTitle,
    alertText,
  };


  return (
    <Alert
      alertData={alertData}
      resolveAlert={clearErrors}
    />
  );
};

ErrorAlertDisplay.propTypes = {
  errorAlerts: PropTypes.arrayOf(PropTypes.object),
  clearErrors: PropTypes.func,
};











const mapStateToProps = (state, ownProps) => ({
  errorAlerts: state.errorAlert.currentErrors,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  clearErrors() {
    dispatch(clearAllErrorAlerts());
  },
});

const ErrorAlert = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorAlertDisplay);






export { ErrorAlert };
